export class InputState {
  constructor(target = globalThis) {
    this.target = target;
    this.down = new Set();
    this.pressed = new Set();
    this.released = new Set();
    this.transitions = [];
    this.gameKeys = new Set([
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "Space",
      "KeyA",
      "KeyD",
      "KeyF",
      "KeyW",
      "KeyP",
      "KeyR",
      "Escape",
      "KeyY",
      "KeyN",
    ]);

    const isEditableTarget = (node) => (
      typeof HTMLElement !== "undefined"
      && node instanceof HTMLElement
      && (
        node.isContentEditable
        || node.tagName === "INPUT"
        || node.tagName === "TEXTAREA"
        || node.tagName === "SELECT"
      )
    );

    this.handleKeyDown = (event) => {
      if (isEditableTarget(event.target)) {
        return;
      }
      if (this.gameKeys.has(event.code)) {
        event.preventDefault();
      }
      if (!this.down.has(event.code)) {
        this.pressed.add(event.code);
        this.transitions.push({ type: "press", code: event.code });
      }
      this.down.add(event.code);
    };

    this.handleKeyUp = (event) => {
      if (isEditableTarget(event.target)) {
        return;
      }
      if (this.gameKeys.has(event.code)) {
        event.preventDefault();
      }
      this.down.delete(event.code);
      this.released.add(event.code);
      this.transitions.push({ type: "rel", code: event.code });
    };

    this.handleWindowBlur = () => {
      for (const code of this.down) {
        this.released.add(code);
        this.transitions.push({ type: "rel", code });
      }
      this.down.clear();
      this.pressed.clear();
    };

    target?.addEventListener?.("keydown", this.handleKeyDown);
    target?.addEventListener?.("keyup", this.handleKeyUp);
    globalThis.addEventListener?.("blur", this.handleWindowBlur);
  }

  dispose() {
    this.target?.removeEventListener("keydown", this.handleKeyDown);
    this.target?.removeEventListener("keyup", this.handleKeyUp);
    globalThis.removeEventListener?.("blur", this.handleWindowBlur);
    this.down.clear();
    this.pressed.clear();
    this.released.clear();
    this.transitions = [];
  }

  beginFrame() {
    this.pressed.clear();
    this.released.clear();
    this.transitions = [];
  }

  isDown(code) {
    return this.down.has(code);
  }

  wasPressed(code) {
    return this.pressed.has(code);
  }
}
